module.exports = __webpack_public_path__ + "img/ic_calendar-1.5ab20d88.svg";